import styled from 'styled-components'
import { SIZES } from '../../../constants'

export default styled.div`
  background: ${props => props.theme.button.background};
  border-radius: 4px;
  color: ${props => props.theme.button.color};
  flex: 1 1 98px;
  font-size: 11px;
  font-weight: bold;
  height: 34px;
  line-height: 34px;
  margin-top: 3px;
  text-align: center;
  text-transform: uppercase;
  width: 98px;

  &:hover {
    background: ${props => props.theme.button.hover.background};
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD}px) {
    & span {
      display: none;
    }
  }
`
